import qs from 'qs';
import hasKey from "lodash-es/has";

const searchObject = qs.parse((location?.search || "").slice(1));
const IS_DEBUG_MODE = hasKey(searchObject, "billing_log");

const theme = `background: green; color: white; padding: 2px; border-radius: 5px; padding: 3px 10px;`;
const errorTheme = `background: red; color: white; padding: 2px; border-radius: 5px; padding: 3px 10px;`;

export const logger = (tag, msg) => IS_DEBUG_MODE && console && console.log(`%c${tag}`, theme, msg);
const loggerError = (tag, msg) => IS_DEBUG_MODE && console && console.log(`%c${tag}`, errorTheme, msg);

const BILLING_PRODUCT_ENTRY_PREFIX = "billingProductEntry--";
logger.productEntry = (tag, msg) => logger(`${BILLING_PRODUCT_ENTRY_PREFIX}${tag}`, msg);
logger.productEntryError = (tag, msg) => loggerError(`${BILLING_PRODUCT_ENTRY_PREFIX}${tag}`, msg);
